module.exports = __webpack_public_path__ + "ddf96ef3837e22f7225c62280e253fcf.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/destructive_abilities-1024.webp.png
// module id = 244
// module chunks = 0